define.alias("shared/components/shared/wizards/carousel/step-two", "preview-grid/components/shared/wizards/carousel/step-two");